angular.module('unica_partner.partner_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider


		// PARTNER
		.state('app.partner', {
			url: '/partner',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/partner/templates/partner.html',
					controller: 'PartnerBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// PARTNER LIST AND DELETE
			.state('app.partner.list', {
				url: '/list',
				views: {
					'partnerContent': {
						templateUrl: './modules/partner/templates/list.html',
						controller: 'PartnerListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Partner'
				}
			})

			// PARTNER CREATE
			.state('app.partner.create', {
				url: '/create',
				views: {
					'partnerContent': {
						templateUrl: './modules/partner/templates/create.html',
						controller: 'PartnerCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Partner',
					parent: 'app.partner.list'
				}
			})

			// PARTNER EDIT
			.state('app.partner.edit', {
				url: '/edit/:id',
				views: {
					'partnerContent': {
						templateUrl: './modules/partner/templates/edit.html',
						controller: 'PartnerEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Partner',
					parent: 'app.partner.list'
				}
			});


});

